import { render, staticRenderFns } from "./hisClient.vue?vue&type=template&id=c5b1ca0c&"
import script from "./hisClient.vue?vue&type=script&lang=js&"
export * from "./hisClient.vue?vue&type=script&lang=js&"
import style0 from "./hisClient.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports